module.exports = __webpack_public_path__ + "static/takmicenje-890896bdc5d2cf010622eff4ff858226.jpg";